/* eslint "react/no-did-mount-set-state": 0 */
import cx                          from 'classnames';
import React, { PropTypes }        from 'react';
import ReactDom                    from 'react-dom';
import HasPercentageWidth          from 'mixins/has_percentage_width';
import { isDescendant, getOffset } from 'utils/util';

export default React.createClass({
  displayName: 'Player.DragBar',
  propTypes: {
     onDragStart: PropTypes.func,
       onDragEnd: PropTypes.func,
           style: PropTypes.object,
        hasScrub: PropTypes.bool,
     currentTime: PropTypes.number,
        duration: PropTypes.number,
    isFullScreen: PropTypes.bool
  },
  mixins: [  HasPercentageWidth ],
  getInitialState() {
    return {
            dragX: 0,
      parentWidth: 1000
    };
  },
  componentDidMount() {
    this.setState({
      parentWidth:  ReactDom.findDOMNode(this).parentNode.getBoundingClientRect().width
    });
  },
  shouldComponentUpdate(nextProps, nextState) {
    if(this.props.currentTime !== nextProps.currentTime) {
      return true;
    }
    if(nextState.dragX === 0 && nextState.isDragging === true) {
      return false;
    }
    if(typeof nextState.dragX === 'undefined') {
      return false;
    }
    if((nextProps.currentTime === 0)) {
      return false;
    } else {
      return true;
    }
  },
  onMouseMove(e) {
    if(!this.props.hasScrub || document.getElementById('tvPlayer').classList.contains('presistant-video')) {
      return;
    }
    const left = (this.props.isFullScreen)? 0: getOffset(ReactDom.findDOMNode(this), document).left;
    this.setState({
      dragX: (e.pageX - left)
    });
  },
  onTouchMove(e) {
    if(!this.props.hasScrub || document.getElementById('tvPlayer').classList.contains('presistant-video')) {
      return;
    }
    e.preventDefault();
    const touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
    this.setState({
      dragX: touch.pageX - getOffset(ReactDom.findDOMNode(this), document).left
    });
  },
  getCursorStyle(elapsed, total) {
    const num = Math.floor(((elapsed / total) * 8) - 9);
    return  {
      'right': `${num}px`
    };
  },
  dragStart(e) {
    if(!this.props.hasScrub || document.getElementById('tvPlayer').classList.contains('presistant-video')) {
      return;
    }
    e.stopPropagation();
    this.setState({
      isDragging: true,
           dragX: 0
    });
    document.addEventListener('mousemove', this.onMouseMove);
    document.addEventListener('mouseup', this.dragEnd);
    document.addEventListener('touchmove', this.onTouchMove);
    document.addEventListener('touchend', this.dragEnd);
  },
  dragEnd(e) {
    if(!this.props.hasScrub || document.getElementById('tvPlayer').classList.contains('presistant-video')) {
      return;
    }
    if(this.state.isDragging === false) {
      return;
    } else {
       document.removeEventListener('mousemove', this.onMouseMove);
       document.removeEventListener('mouseup', this.dragEnd);
       document.removeEventListener('touchmove', this.onTouchMove);
       document.removeEventListener('touchend', this.dragEnd);
      if(this.props.onDragEnd &&
        (!isDescendant(document.querySelector('.video-player-progress-bar-wrap'), e.target))) {
        this.props.onDragEnd(e);
      }
    }
    this.setState({
      isDragging: false
    });
  },
  killEvent(e) {
    e.stopPropagation();
  },
  render() {
    const classNames  = cx({
      'video-player-elapsed-time-indicator': true,
                              'is-dragging': this.state.isDragging
    }),
    parentWidth = this.props.isFullScreen? document.documentElement.offsetWidth: this.state.parentWidth,
    style = (this.state.isDragging) ?
              this.getStyle(this.state.dragX, parentWidth, this.props.isFullScreen):
              this.props.style;
    const cursorStyle = this.getCursorStyle(this.props.currentTime, this.props.duration);
    if(this.props.hasScrub) {
      return (
        <div   className={classNames}
             onMouseDown={this.dragStart}
               onMouseUp={this.dragEnd}
                 onClick={this.killEvent}
            onTouchStart={this.dragStart}
              onTouchEnd={this.dragEnd}
             onTouchMove={this.touchMove}
                   style={style} >
          <div className="draggable-medtv"
               style={cursorStyle}></div>
        </div>
      );
    } else {
      return (<div className={classNames} style={style}></div>);
    }
  }
});



/** WEBPACK FOOTER **
 ** ./modules/components/player/drag_bar.jsx
 **/